/**
 * Created by vladislav on 18/05/2023
 */

const GameLevelConfig = {};

(function () {
    const GameLevelConfigData = { 
        main: {
            calcThreshold: function () {
                const threshold = [20, 45, 150, 400, 550, 1500, 2500];
                let delta = 1400;
                for (let i = threshold.length; i < 100; i++) {
                    threshold.push(threshold[i - 1] + delta);
                    delta += 200;
                }

                return threshold;
            },
            calcReward: function (level) {
                switch (level) {
                    case 0:
                        return {
                            rubies: 5,
                            soft: 150
                        };

                    case 1:
                        return {
                            rubies: 5,
                            energy: 25,
                            soft: 50
                        };

                    case 2: case 3: case 4:
                        return {
                            rubies: 10,
                            energy: 30,
                            soft: 50
                        };

                    case 5: case 6: case 7:
                        return {
                            rubies: 5,
                            energy: 50,
                            soft: 100
                        };

                    default:
                        return {
                            rubies: 10,
                            energy: 100,
                            soft: 150
                        };
                }
            }
        },

        collections: {
            calcThreshold: function () {
                const threshold = [5, 20, 30, 90, 160];
                let delta = 10;
                for (let i = threshold.length; i < 21; i++) {
                    threshold.push(threshold[i - 1] + delta);
                    delta += 5;
                }
                return threshold;
            },

            calcReward: function (level) {
                if (level < 3) {
                    return {
                        hard: 5,
                        soft: 50,
                        wands: 5
                    };
                }
                if (level < 19) {
                    return {
                        hard: 5,
                        soft: 100,
                        wands: 5
                    };
                }

                return {
                    hard: 5,
                    soft: 150,
                    wands: 5
                };
            }
        }
    };

    for (const id in GameLevelConfigData) {
        GameLevelConfig[id] = {
            threshold: GameLevelConfigData[id].calcThreshold(),
            calcReward: GameLevelConfigData[id].calcReward
        };
    }
}());